import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm04 from "../data/form04.data";

type Props = {
  onSubmit: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true;
};
const Form04: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const [inputValueFormLeave04, setInputValueFormLeave04] = useState({
    information: {
      received_summons: "",
      received_summons_address: "",
      received_summons_date: "",
      received_summons_receive: "",
      received_summons_place: "",
      received_summons_since_date: "",
      received_summons_scheduled_date: "",
    },
  });

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave04.information;

    setData({
      main: information,
      condition: condition,
    });
  }, [inputValueFormLeave04]);

  useEffect(() => {
    if (data?.condition) {
      setInputValueFormLeave04({
        information: data.condition,
      });
    }
  }, []);

  return (
    <FormComponent
      formGenerate={generateForm04}
      inputValue={inputValueFormLeave04}
      setInputValue={setInputValueFormLeave04}
      handleCheckValid={isValidateForm}
      isCanEdit={isCanEdit ?? true}
      permission={"admin"}
    />
  );
};

export default Form04;
